// CUSTOM MODULES
import Defaults from "./classes/defaults";
import Filter from "./classes/filter";
import Toggle from "./classes/toggle";

class App {
    /**
     *  Constructor
     */
    constructor() {
        this.onDocumentReady(this.init);
    }

    onDocumentReady(fn) {
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            // call on next available tick
            setTimeout(fn, 1);
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    init() {
        new Defaults();
        new Toggle();

        const bodyClassList = document.querySelector('body').classList;
        if (bodyClassList.contains('ProductOverview') || bodyClassList.contains('ProductCategory')) {
            new Filter();
        }
        if (bodyClassList.contains('ProductDetail') || bodyClassList.contains('TrainingDetail')) {
            GLightbox({
                selector: 'photo-thumb'
            });
        }
    }
}

window.app = new App();